import { Typography } from '@mui/material';
import './ViewStudentAnswersNotification.scss';

const ViewStudentAnswersNotification = ({
  message,
}) => (
  <div className='view-student-answers-notification'>
    <Typography variant='h4' className='view-student-answers-notification-message'>
      {message}
    </Typography>
  </div>
);

export default ViewStudentAnswersNotification;
